<template>
<div>
  <div class="properties">
    <property :name="'סוג מנוי'" :value="'מנוי לא פעיל'"/>
    <property :name="'סיום תקופת הניסיון'" :value="trialEndDateFormatted"/>
    <div class="promo-notification-box-container">
      <benefit-notification-box/>
    </div>
  </div>
  <div class="separator"/>
  <div class="subscribe-button-container">
    <riseup-button class="subscribe-button" :action="subscribeClicked"
                   :title="'הרשמה עם כרטיס אשראי'"/>
  </div>
</div>
</template>

<script>
import BaseUI from 'base-ui';
import { mapState } from 'vuex';
import BenefitNotificationBox from './components/BenefitNotificationBox.vue';
import dates from '../../../../../utils/dates';
import Property from './Property.vue';
import SubscribeClickHandler from './SubscribeClickHandler.vue';

export default {
  name: 'DormantAfterTrialSettings',
  components: {
    Property,
    RiseupButton: BaseUI.RiseupButton,
    BenefitNotificationBox,
  },
  mixins: [SubscribeClickHandler],
  computed: {
    ...mapState('subscriptionState', ['since']),
    trialEndDateFormatted() {
      return dates.longHebrewDateFormat(this.since);
    },
  },
};
</script>

<style scoped lang="scss">

  @import "~base-ui/src/scss/riseup-colors";
  @import "./settings";

  @include properties;

  .promo-notification-box-container {
    padding: 0 23px;
  }

  .separator {
    height: 1px;
    background-color: $riseup_gray_0;
  }

  .subscribe-button-container {
    display: flex;
    justify-content: center;
    align-items: center;

    .subscribe-button {
      margin: 23px;
      width: 100%;
    }
  }
</style>
